import { strengths } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function Strengths() {
  return (
    <section id="strengths" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-10">
        <div className="reveal">
          <SectionHeading
            eyebrow="Core Strengths"
            title="为什么选择我们"
            subtitle="品类齐全、品质可靠、价格合理、配送高效，是我们服务每一位客户的底气。"
          />
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {strengths.map((item, index) => (
            <article
              key={item.title}
              className="reveal group p-6 md:p-7 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-5 font-heading font-semibold text-foreground-950 text-base md:text-lg">
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}